module.exports = __webpack_public_path__ + "img/activity_52.13494a50.png";